// extracted by mini-css-extract-plugin
module.exports = {"back":"BackIcon_back__60Q8N","row":"BackIcon_row__3JA93"};